export type Channel = 'whatsapp' | 'instagram';
export type ConvStatus = 'open' | 'pending' | 'resolved';
export type AiState = 'active' | 'paused' | 'escalated';

export interface Conversation {
  id: string;
  channel: Channel;
  channelAccount: string | null;
  contactId: string;
  contactName: string | null;
  contactHandle: string | null;
  customerId: string | null;
  status: ConvStatus;
  assignee: { id: string; name: string | null } | null;
  aiState: AiState;
  escalationReason: string | null;
  lastMessageAt: string;
  lastInboundAt: string | null;
  preview: string | null;
  lastDirection: string | null;
  unread: number;
  replyOpen: boolean;
}

export interface ThreadMessage {
  id: string;
  direction: 'inbound' | 'outbound';
  type: string;
  body: string | null;
  templateName: string | null;
  status: string;
  errorTitle: string | null;
  sentAt: string;
  sentBy: string | null;
  origin: 'customer' | 'agent' | 'ai' | 'system';
  campaign: boolean;
}

export interface Note {
  id: string;
  body: string;
  author: string | null;
  authorId: string | null;
  createdAt: string;
}

export interface QuickReply {
  id: string;
  shortcut: string;
  title: string;
  body: string;
}

export interface Detail {
  conversation: Conversation;
  customer: {
    id: string;
    name: string | null;
    email: string | null;
    phone: string | null;
    ordersCount: number;
    totalSpent: string;
    lastOrderAt: string | null;
  } | null;
  events: Array<{
    id: string;
    kind: string;
    actor: string | null;
    data: Record<string, unknown> | null;
    createdAt: string;
  }>;
}

export const contactLabel = (
  c: Pick<Conversation, 'contactName' | 'contactHandle' | 'contactId' | 'channel'>,
) =>
  c.contactName ??
  (c.contactHandle
    ? `@${c.contactHandle}`
    : c.channel === 'whatsapp'
      ? `+${c.contactId}`
      : c.contactId);
